import { ActionType } from '../action-types/index'
import { InventoryAction } from '../actions/index'
import { InventoryChangeType, InventoryState } from "../../models"

const initialInventoryState: InventoryState = { inventory: 15, changeType: InventoryChangeType.Adjust }

const inventoryStateReducer = (state: InventoryState = initialInventoryState, action: InventoryAction) => {
    switch (action.type) {
        case ActionType.UpdateInventory:
            return state = {inventory: action.payload.value, changeType: state.changeType}
        case ActionType.UpdateInventoryType:
            return state = {inventory: state.inventory, changeType: action.payload.type}
        default:
            return state
    }
}

export default inventoryStateReducer